import { render } from "./types.vue?vue&type=template&id=90b7fa22"
import script from "./types.vue?vue&type=script&lang=js"
export * from "./types.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__